enum EImagingTaskState {
  NotCompleted = 0,
  Skipped = 1,
  Pending = 3,
  Queued = 4,
  Imaging = 5,
  Completed = 6,
  Cancelled = 7,
}

export default EImagingTaskState;
